import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {ArrowDownSquareFill, InfoCircleFill} from "react-bootstrap-icons";
import {Util} from "../../components/Util";
import {TBody} from "../../components/Table/TBody";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {Dictionary} from "../../components/Dictionary";

export class InventoryList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return `/inventory/list`;
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData();
        const dictionary: Dictionary = this.dictionary;
        const statuses = this.state?.item?.statuses || [];

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'location', defaultValue: params?.location}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'status',
                                        basic: 'show-all',
                                        items: ['valid','in-progress','invalid','cancelled'],
                                        // defaultValue: params?.status || 'valid'
                                        defaultValue: params?.status || 'valid'
                                    }}/>
                                </div>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'i.id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/inventory/list-export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>

                                &nbsp;
                                &nbsp;
                                <h6 style={{width: '100%'}}>
                                    {this.dictionary.get['inventory-list']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>

                        <div className="row" style={{marginBottom: '10px'}}>
                            {statuses.map(function (elem: any) {
                                return (
                                    <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                        {Util.searchStatus(elem.status, {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 'normal'
                                            }
                                        })}
                                        &nbsp;<FormattedNumber value={elem.count}/>
                                        &nbsp;{dictionary.get['pc']}
                                    </div>);
                            })}
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['item_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.item_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['product_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.product_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['shipped_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.shipped_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="i.id">
                                    #ID<i className="bi bi-sort-down"></i>
                                </th>

                                <th>{this.dictionary.get['status']}</th>

                                <th className="sortable" data-sortkey="i.sku">
                                    {this.dictionary.get['sku']}
                                </th>
                                <th className="sortable" data-sortkey="p.`name`">
                                    {this.dictionary.get['product_name']}
                                </th>
                                <th className="sortable" data-sortkey="i.location">
                                    {this.dictionary.get['location']}
                                </th>
                                <th className="sortable" data-sortkey="i.quantity">
                                    {this.dictionary.get['quantity']}
                                </th>
                                <th className="sortable" data-sortkey="i.quantity_original">
                                    {this.dictionary.get['quantity_original']}
                                </th>
                                <th className="sortable" data-sortkey="i.quantity_diff">
                                    {this.dictionary.get['quantity_diff']}
                                </th>
                                <th className="sortable" data-sortkey="i.created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                                <th className="sortable" data-sortkey="i.updated_at">
                                    {this.dictionary.get['updated_at']}
                                </th>
                                <th className="sortable" data-sortkey="u.`name`">
                                    {this.dictionary.get['created_by']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.id + '-sku:' + elem.sku} data-id={elem.id}>
                                        <td align={'right'}>{elem.id}.</td>
                                        <td>{Util.status(elem.status, {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 600
                                            }
                                        })}</td>
                                        {Util.searchCell(elem.sku, 'sku')}
                                        <td>{elem.product_name}</td>
                                        {Util.searchCell(elem.location, 'location')}
                                        <td>{elem.quantity}</td>
                                        <td>{elem.quantity_original}</td>
                                        <td>{elem.quantity_diff}</td>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                        <td><DateTime value={elem.updated_at} inline={true}/></td>
                                        <td>{elem.user_name} &lt;{elem.user_email}&gt;</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
